import { render } from "./PreviousDateIcon.vue?vue&type=template&id=2f4f0175"
import script from "./PreviousDateIcon.vue?vue&type=script&lang=js"
export * from "./PreviousDateIcon.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__